/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ServicesInputs */

const en_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerings`)
};

const ar_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عروضي`)
};

const bn_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অফারিংস`)
};

const de_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote`)
};

const es_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const fr_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres`)
};

const pt_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const zh_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务方案`)
};

const tr_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifler`)
};

const ru_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложения`)
};

const pl_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferty`)
};

/**
* | output |
* | --- |
* | "Offerings" |
*
* @param {Nav_ServicesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const nav_services = /** @type {((inputs?: Nav_ServicesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ServicesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_nav_services(inputs)
	if (locale === "bn") return bn_nav_services(inputs)
	if (locale === "de") return de_nav_services(inputs)
	if (locale === "es") return es_nav_services(inputs)
	if (locale === "fr") return fr_nav_services(inputs)
	if (locale === "pt") return pt_nav_services(inputs)
	if (locale === "zh") return zh_nav_services(inputs)
	if (locale === "tr") return tr_nav_services(inputs)
	if (locale === "ru") return ru_nav_services(inputs)
	if (locale === "pl") return pl_nav_services(inputs)
	return en_nav_services(inputs)
});